module.exports = __webpack_public_path__ + "media/src/images/bg-shadow-for-icon-cf249bc7d2db2aa282053f82ffbb6ae9.png";